import { render, staticRenderFns } from "./WordEditorBanner.vue?vue&type=template&id=4c58130e&"
import script from "./WordEditorBanner.vue?vue&type=script&lang=ts&"
export * from "./WordEditorBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports